import axios from "axios";
import React from "react";
import { Button, Card, Container, Form } from "react-bootstrap";
import swal from "sweetalert";

const MakeAdmin = ({ token }) => {
  const submitMakeAdminHandler = () => {
    const email = document.getElementById("makeAdminInput").value.trim();
    if (email === "") {
      return alert("please enter a email");
    }
    axios
      .get(`https://mysterious-sierra-48850.herokuapp.com/makeAdmin/${email}`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        console.log(data.data);
        if (data?.data.success) {
          swal(``, `${data?.data?.message}`, "success");
        }
      })
      .catch((err) => {
        console.log(err.response.data);
        swal("", `${err.response?.data?.message}`, "error");
      });
  };
  return (
    <div>
      <Card style={{ width: "100vh", maxWidth: "500px" }} className="mx-auto">
        <Card.Title className="text-center">Make Admin</Card.Title>
        <Card.Body>
          <Form.Control placeholder="enter email" id="makeAdminInput" />
          <Button onClick={submitMakeAdminHandler} className="mt-2">
            Submit
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default MakeAdmin;
